<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <div v-if="!dialogVisible">
      <span class="title">校区课程</span>
      <div style="margin-top:30px;">
        <el-select v-model="value" placeholder="请选择" @change="elselect">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="title_bottom">
        <ul>
          <li
            v-for="(item, index) in tabbleData"
            :key="index"
            @click="getIntoCurriculum(item)"
          >
            <img
              v-if="item.CourseType == 'C++'"
              src="../assets/stylus/image/icon_c++.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="item.CourseType == 'Python'"
              src="../assets/stylus/image/icon_python.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="item.CourseType == 'Scratch'"
              src="../assets/stylus/image/icon_Scratch.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="item.CourseType == '机器人'"
              src="../assets/stylus/image/robot.png"
              style="width: 130px; position: absolute;"
            />
            <div
              class="examine"
              v-if="value == false && userInfo.ApproveCourse == true"
            >
              <el-button
                size="mini"
                icon="el-icon-check"
                type="success"
                @click.stop="approval(item.Id, true)"
                style="padding:4px 6px; font-weight: 400;"
              >
                通过
              </el-button>
              <el-button
                size="mini"
                icon="el-icon-close"
                type="danger"
                @click.stop="approval(item.Id, false)"
                style="padding:4px 6px; font-weight: 400;"
              >
                拒绝
              </el-button>
            </div>
            <div class="top_img">
              <span class="top_img_title">{{ item.Name }}</span>
              <el-button type="primary" size="mini">进入章节</el-button>
              <el-button
                plain
                type="primary"
                size="mini"
                @click.stop="distribution(item)"
                v-if="userInfo.user_role[0].Subject.Name == 'ADMIN'"
              >
                分配课程</el-button
              >
              <el-button
                plain
                type="primary"
                size="mini"
                @click.stop="distribution(item)"
                v-if="role == 'HEADMASTER'"
              >
                分配课程
              </el-button>
            </div>
            <img :src="item.Image" style="height:100%;" />
          </li>
        </ul>
      </div>
    </div>

    <!-- 章节内容 -->
    <div v-if="dialogVisible">
      <div v-if="!dialog_handout">
        <span class="title">{{ select_chapterList.Name }}</span>
        <div>
          <el-button
            icon="el-icon-top-left"
            size="mini"
            plain
            type="primary"
            style="margin-top:20px;"
            @click="return_curriculum('curriculum')"
          >
            返回课程
          </el-button>
        </div>
        <ul style="margin-top:0;">
          <li
            v-for="(item, index) in select_chapterList.Chapters"
            :key="index"
            @click="getIntoChapter(item, select_chapterList.CourseType)"
          >
            <img
              v-if="select_chapterList.CourseType == 'C++'"
              src="../assets/stylus/image/icon_c++.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="select_chapterList.CourseType == 'Python'"
              src="../assets/stylus/image/icon_python.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="select_chapterList.CourseType == 'Scratch'"
              src="../assets/stylus/image/icon_Scratch.png"
              style="width: 130px; position: absolute;"
            />
            <img
              v-if="select_chapterList.CourseType == '机器人'"
              src="../assets/stylus/image/robot.png"
              style="width: 130px; position: absolute;"
            />
            <div class="top_img">
              <span class="top_img_title">{{ item.Name }}</span>
              <el-button type="primary" size="mini">进入讲义</el-button>
              <el-button
                icon="el-icon-view"
                type="warning"
                size="mini"
                @click.stop="hide(item)"
              >
                隐藏
              </el-button>
            </div>
            <img :src="item.UpdatedAt" style="height:100%;" />
          </li>
        </ul>
      </div>
    </div>
    <!-- 章节内容 -->

    <!-- 讲义内容 -->
    <div v-if="dialog_handout">
      <span class="title">{{ select_handoutList.Name }}</span>
      <div style="margin-top:20px;">
        <el-button
          icon="el-icon-top-left"
          size="mini"
          plain
          type="primary"
          @click="return_curriculum('chapter')"
          >返回章节</el-button
        >
      </div>

      <el-tabs v-model="activeName" style="width:100%;">
        <el-tab-pane label="讲义" name="讲义">
          <ul>
            <li
              v-for="(item, index) in select_handoutList.Handouts"
              :key="index"
              @click="seeHandout(item)"
              :style="item.PdfId || item.MaterialId ? 'height:0;border:0;' : ''"
            >
              <img
                v-if="select_handoutList.CourseType == 'C++'"
                src="../assets/stylus/image/icon_c++.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Python'"
                src="../assets/stylus/image/icon_python.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Scratch'"
                src="../assets/stylus/image/icon_Scratch.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_chapterList.CourseType == '机器人'"
                src="../assets/stylus/image/robot.png"
                style="width: 130px; position: absolute;"
              />

              <a :href="url" target="_blank">
                <div class="top_img">
                  <span class="top_img_title">{{ item.Name }}</span>
                  <el-button type="primary" size="mini">查看讲义</el-button>
                </div>
                <img :src="item.UpdatedAt" style="height:100%;" />
              </a>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="PDF" name="PDF">
          <ul>
            <li
              v-for="(item, index) in select_handoutList.Handouts"
              :key="index"
              @click="seeHandout(item)"
              :style="item.PdfId ? '' : 'height:0;border:0;'"
            >
              <img
                v-if="select_handoutList.CourseType == 'C++'"
                src="../assets/stylus/image/icon_c++.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Python'"
                src="../assets/stylus/image/icon_python.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Scratch'"
                src="../assets/stylus/image/icon_Scratch.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_chapterList.CourseType == '机器人'"
                src="../assets/stylus/image/robot.png"
                style="width: 130px; position: absolute;"
              />

              <a :href="item.UpdatedAt" target="_blank">
                <div class="top_img">
                  <span class="top_img_title">{{ item.Name }}</span>
                  <el-button type="primary" size="mini">查看pdf</el-button>
                </div>
                <img src="../assets/stylus/image/pdf.png" class="zip_img" />
              </a>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="压缩包" name="压缩包">
          <ul>
            <li
              v-for="(item, index) in select_handoutList.Handouts"
              :key="index"
              :style="item.MaterialId ? '' : 'height:0;border:0;'"
            >
              <img
                v-if="select_handoutList.CourseType == 'C++'"
                src="../assets/stylus/image/icon_c++.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Python'"
                src="../assets/stylus/image/icon_python.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_handoutList.CourseType == 'Scratch'"
                src="../assets/stylus/image/icon_Scratch.png"
                style="width: 130px; position: absolute;"
              />
              <img
                v-if="select_chapterList.CourseType == '机器人'"
                src="../assets/stylus/image/robot.png"
                style="width: 130px; position: absolute;"
              />

              <a :href="item.UpdatedAt">
                <div class="top_img">
                  <span class="top_img_title">{{ item.Name }}</span>
                  <el-button type="primary" size="mini">下载压缩包</el-button>
                </div>
                <img class="zip_img" src="../assets/stylus/image/yasuo.png" />
              </a>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 讲义内容 -->

    <!-- 课程分配弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="分配课程"
      :visible.sync="dialog_distribution"
      width="40%"
    >
      <el-form ref="form" label-width="40px">
        <el-form-item
          label="校区"
          v-if="userInfo.user_role[0].Subject.Name == 'ADMIN'"
        >
          <el-select
            style="width:100%;"
            multiple
            clearable
            v-model="form.school"
            placeholder="请选择校区"
          >
            <el-option
              v-for="item in select_campus"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="老师" v-if="role == 'HEADMASTER'">
          <el-select
            multiple
            style="width:100%;"
            v-model="form.teacher"
            placeholder="请选择老师"
            clearable
          >
            <el-option
              v-for="item in select_teacher"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_distribution = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="dialog_distribution_is" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import { getCourse } from "@/api/addAccount.js";
import { getSchool, get_add_principal } from "@/api/admin.js";
import {
  put_distribution_school_api,
  put_distribution_teacher_api,
  put_course_approval_api,
  put_course_hidden_api,
} from "@/api/viewCourse.js";
import { post_image_url_api } from "@/api/resources.js";
export default {
  computed: {
    ...mapGetters(["current", "userInfo"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      activeName: "讲义",
      dialogVisible: false,
      dialog_handout: false,
      dialog_distribution: false,
      tabbleData: [],
      select_chapterList: {},
      select_handoutList: {},
      url: "",
      form: { school: [], teacher: [] },
      select_campus: [], //下拉框校区
      select_teacher: [], //下拉框老师
      options: [
        {
          value: true,
          label: "审核通过",
        },
        {
          value: false,
          label: "审核未通过",
        },
      ],
      value: true,
      role: "",
      loading_ok: "",
    };
  },

  watch: {
    current() {
      this.getCourse_but();
    },
  },

  created() {
    this.role = JSON.parse(sessionStorage.getItem("role"));
    this.getCourse_but();
    if (this.role != "TEACHER") {
      this.get_school();
      this.get_principal();
    }
  },

  methods: {
    // 获取校区
    get_school() {
      getSchool().then((res) => {
        this.select_campus = res.data;
      });
    },

    //获取课程
    getCourse_but() {
      getCourse(this.current, this.value).then((response) => {
        response.data.forEach((v) => {
          post_image_url_api([v.Image]).then((res) => {
            v.Image = "http://" + res.data[0];
          });
        });
        this.loading_ok = false;
        this.tabbleData = response.data;
      });
    },

    //获取老师
    get_principal() {
      let data = {
        domain: {
          group: "SCHOOL",
          name: this.current,
        },
        subject: {
          group: "ROLE",
          name: "TEACHER",
        },
      };

      // 获取校区下面的老师
      get_add_principal(data).then((res) => {
        this.select_teacher = res.data;
      });
    },

    // 进入章节
    getIntoCurriculum(item) {
      if (item.Chapters.length) {
        this.dialogVisible = true;
        item.Chapters.forEach((v) => {
          post_image_url_api([v.Image]).then((res) => {
            v.UpdatedAt = "http://" + res.data[0];
          });
        });

        this.select_chapterList = item;
      } else {
        this.$message.error("该课程未添加章节！");
      }
    },

    // 进入讲义按钮
    getIntoChapter(item, type) {
      if (item.Handouts.length) {
        this.dialog_handout = true;
        item.Handouts.forEach((v) => {
          if (v.PdfId) {
            post_image_url_api([v.PdfId]).then((res) => {
              v.UpdatedAt = "http://" + res.data[0];
            });
          } else if (v.MaterialId) {
            post_image_url_api([v.MaterialId]).then((res) => {
              v.UpdatedAt = "http://" + res.data[0];
            });
          } else {
            post_image_url_api([v.Image]).then((res) => {
              v.UpdatedAt = "http://" + res.data[0];
            });
          }
        });
        this.select_handoutList.CourseType = type;
        this.select_handoutList = item;
      } else {
        this.$message.error("该章节未添加讲义！");
      }
    },

    // 查看讲义
    seeHandout(item) {
      this.url = item.File.Url;
    },

    // 分配课程
    distribution(item) {
      this.form.school = item.Schools;
      this.form.teacher = item.Users;
      this.form.CourseId = item.Id;
      this.dialog_distribution = true;
    },

    // 分配弹框确定
    dialog_distribution_is() {
      if (this.userInfo.user_role[0].Subject.Name == "ADMIN") {
        let data = {
          CourseId: this.form.CourseId,
          schools: this.form.school,
        };
        put_distribution_school_api(data).then(() => {
          this.getCourse_but();
          this.$message.success("修改成功！");
          this.dialog_distribution = false;
        });
      } else if (this.role == "HEADMASTER") {
        let data = {
          courseId: this.form.CourseId,
          schoolName: this.current,
          users: this.form.teacher,
        };
        put_distribution_teacher_api(data).then(() => {
          this.getCourse_but();
          this.$message.success("修改成功！");
          this.dialog_distribution = false;
        });
      }
    },

    //下拉框选中值发生变化
    elselect() {
      this.getCourse_but();
    },

    //审核
    approval(id, type) {
      let data = {
        approved: type,
        courseId: id,
      };

      put_course_approval_api(data).then((res) => {
        this.getCourse_but();
      });
    },

    //返回课程
    return_curriculum(type) {
      if (type == "curriculum") {
        this.dialogVisible = false;
      } else {
        this.dialog_handout = false;
      }
    },

    //隐藏
    hide(item) {
      this.$confirm("确定隐藏吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          put_course_hidden_api({
            approved: false,
            courseId: item.Id,
          }).then(() => {
            this.getCourse_but();
            this.$message.success("隐藏成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin: 16px;

  .title {
    color: #333;
    font-size: 20px;
  }

  .title_bottom {
    margin-top: 0px;

    .title {
      font-size: 18px;
      color: #666;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-top: 20px;
      margin-right: 20px;
      cursor: pointer;
      width: 18%;
      height: 230px;
      border-radius: 4px;
      border:1px solid #eee;
      overflow: hidden;
      position: relative;

      .top_img {
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 10px;
        z-index: 2;
        text-align: center;

        .top_img_title {
          color: #fff;
          font-size: 14px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .el-button {
          padding: 3px 12px;
          margin-top: 6px;
          font-weight: 400;
        }
      }

      .examine {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
      }

        .zip_img {
          width:100%;
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50% , -50%);
       }
    }
  }

  .add_but {
    display: block;
    margin-top: 20px;
  }
}
</style>
